import { apiFetch } from '@shared/api/http'

export interface PrecoProduto {
  valor: string
  moeda: string
  jaImportada: boolean
  nomePlano?: string
}

export interface LegacyPlano {
  nome: string
  valor: number
  moeda: string
}

export interface ProdutoImportavel {
  legacyId: string
  nome: string
  descricao: string
  imagemUrl: string | null
  paginaVendas: string | null
  importavel: boolean
  precos: PrecoProduto[]
  categoria?: number
  emailSuporte?: string
  nomeSuporte?: string
  garantiaProduto?: number | null
  metodoPagamento?: number[]
  recorrencia?: boolean
  planos?: LegacyPlano[]
}

export interface LegacyImportStatusResponse {
  status: 'NOT_APPLICABLE' | 'OFFERED' | 'COMPLETED' | 'EXPIRED'
  expiresAt?: string
  produtos?: ProdutoImportavel[]
}

export interface ExecuteProdutoInput {
  legacyId: string
  valor: string
  moeda: string
}

export interface ExecuteResult {
  importados: number
  pendentes: string[]
}

export function fetchLegacyImportStatus(): Promise<LegacyImportStatusResponse> {
  return apiFetch<LegacyImportStatusResponse>('/legacy-import/status')
}

export function executeLegacyImport(
  produtos: ExecuteProdutoInput[],
  legacyProdutos: ProdutoImportavel[],
): Promise<ExecuteResult> {
  return apiFetch<ExecuteResult>('/legacy-import/execute', {
    method: 'POST',
    body: {
      produtos,
      legacyProdutos: legacyProdutos.map((p) => ({
        id: p.legacyId,
        nome: p.nome,
        descricao: p.descricao,
        tipoProduto: 1,
        imagemProduto: p.imagemUrl,
        paginaVendas: p.paginaVendas,
        precos: p.precos.map((pr) => ({ valor: parseFloat(pr.valor), moeda: pr.moeda })),
        ...(p.categoria !== undefined && { categoria: p.categoria }),
        ...(p.emailSuporte && { emailSuporte: p.emailSuporte }),
        ...(p.nomeSuporte && { nomeSuporte: p.nomeSuporte }),
        ...(p.garantiaProduto != null && { garantiaProduto: p.garantiaProduto }),
        ...(p.metodoPagamento !== undefined && { metodoPagamento: p.metodoPagamento }),
        ...(p.recorrencia !== undefined && { recorrencia: p.recorrencia }),
        ...(p.planos !== undefined && { planos: p.planos }),
      })),
    },
  })
}
